import { render } from "./DetailsSkeleton.vue?vue&type=template&id=ef5b6300&scoped=true"
import script from "./DetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailsSkeleton.vue?vue&type=script&lang=js"

import "./DetailsSkeleton.vue?vue&type=style&index=0&id=ef5b6300&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5b6300"]])

export default __exports__